/**
 * LibKey Nomad — one-click access to library-subscribed full text
 *
 * Its web-accessible-resource entry lists `images/libkey-nomad-flame.png`,
 * `images/browzine-logo.png` and everything under `static/`, exposed to every http(s)
 * origin with no `use_dynamic_url`. Every content-script asset is therefore fetchable
 * from any page at a fixed URL.
 *
 * The two branded images are the strongest signal — vendor-named and loadable without a
 * CORS grant. The content-script bundle corroborates and would survive the images being
 * renamed.
 *
 * Manifest verified against version 1.58.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lkoeejijapdihgbegpljiehpnlkadljb';

export const libkeyNomad: ExtensionDefinition = {
  id: ID,
  name: 'LibKey Nomad',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Exposes branded images and static/* to http(s) origins with no dynamic URL. ' +
    'The libkey-nomad-flame / browzine-logo images are conclusive and CORS-free.',
  signals: [
    {
      id: 'war-flame-image',
      kind: 'web-accessible-resource',
      description:
        'Load images/libkey-nomad-flame.png via <img> — the extension\'s brand mark, ' +
        'exposed to every http(s) origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/libkey-nomad-flame.png'),
    },
    {
      id: 'war-browzine-logo',
      kind: 'web-accessible-resource',
      description:
        'Load images/browzine-logo.png via <img>. BrowZine is the vendor\'s sibling ' +
        'product; the logo corroborates the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/browzine-logo.png'),
    },
    {
      id: 'war-content-main-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch static/content-main.js — the injected content script, exposed at a ' +
        'stable path and independent of the image names.',
      weight: 0.5,
      run: () => probeFetch(ID, 'static/content-main.js'),
    },
  ],
};
